import katex from "katex";
import "katex/dist/katex.min.css";

interface FormulaRendererProps {
  equation: string;
  displayMode?: boolean;
}

const formulaCardStyle: React.CSSProperties = {
  margin: "var(--space-6) 0",
  padding: "var(--space-5)",
  background: "var(--bg-surface)",
  border: "1px solid var(--border-color)",
  borderRadius: "var(--radius-md)",
  overflowX: "auto",
  textAlign: "center",
  fontSize: "var(--text-lg)",
};

/**
 * Renders KaTeX at build/render time via renderToString so the formula ships
 * inside the prerendered HTML (crawlable, zero CLS) instead of hydrating in a
 * client effect. Falls back to the raw TeX string if parsing fails.
 */
export default function FormulaRenderer({ equation, displayMode = true }: FormulaRendererProps) {
  // Strip \[ \] or $$ $$ delimiters if present – we pass displayMode explicitly
  let tex = equation.trim();
  if (tex.startsWith("\\[") && tex.endsWith("\\]")) {
    tex = tex.slice(2, -2).trim();
  } else if (tex.startsWith("$$") && tex.endsWith("$$")) {
    tex = tex.slice(2, -2).trim();
  }

  let html: string;
  try {
    html = katex.renderToString(tex, {
      displayMode,
      throwOnError: false,
      strict: false,
      trust: false,
      output: "html",
    });
  } catch {
    return <div className="katex-formula" style={formulaCardStyle}>{equation}</div>;
  }

  return <div className="katex-formula" style={formulaCardStyle} dangerouslySetInnerHTML={{ __html: html }} />;
}
